export default __webpack_public_path__ + "static/media/Apple.6fa85152.svg";